import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "tips-box"
};
const _hoisted_2 = ["accept"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", {
    class: "file-label",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.handleUpload && $options.handleUpload(...args))
  }, [_renderSlot(_ctx.$slots, "default", {}, () => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
    type: "primary"
  }, {
    default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("上传文件")])),
    _: 1,
    __: [2]
  }), _createElementVNode("div", {
    class: "progress",
    style: _normalizeStyle({
      width: $data.uploadProgress + '%'
    })
  }, null, 4)])], true), _createElementVNode("input", {
    type: "file",
    name: "file",
    id: "fileid",
    ref: "inputFile",
    class: "file-input",
    onChange: _cache[0] || (_cache[0] = (...args) => $options.handleInputFileChange && $options.handleInputFileChange(...args)),
    accept: $props.accept
  }, null, 40, _hoisted_2)]);
}